import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import SectionCard from "../../components/SectionCard";
import SectionRow from "../../components/SectionRow";
import { renderSettingsResourceLabel } from "utils/helpers/settings";

function Organization({ user }: any) {
    const { t } = useTranslation();

    const userOrganisationLevels = useMemo(
        () => [user?.level1, user?.level2, user?.level3, user?.level4],
        [user],
    );

    const activeGroups = useMemo(
        () => user?.orgLevelGroups?.filter((group: any) => group?.status !== "deleted") ?? [],
        [user],
    );

    if (!activeGroups.length) return null;

    return (
        <SectionCard title={t("organization")}>
            {activeGroups.map(({ description }: any, i: number) => (
                <SectionRow
                    key={i}
                    label={description}
                    value={userOrganisationLevels[i] ? renderSettingsResourceLabel(userOrganisationLevels[i]) : undefined}
                />
            ))}
        </SectionCard>
    );
}

export default Organization;
